
<div id="layout">
  <div class="d-flex justify-content-center">
    <h5>{{ floorToView?.name }}</h5>
  </div>
  <img
    #miImagen
    id="miImagen"
    src="{{floorToView?.uri}}"
    alt="Imagen"
    (load)="createCanvas()"
  />
  <canvas
    #miCanvas
    id="miCanvas"
    class="cursor-personalizado"
    style="position: absolute; top: 10; left: 1.5%; cursor: pointer;"
  ></canvas>
</div>
